<template>
  <div class="pi-wx-qrcode">
    <div class="pi-wx-qrcode-box">
      <div class="qrcode-img">
        <img v-if="operData.wxMchConfigInfo" :src="operData.wxMchConfigInfo.qrCodeUrl | getFilePath" alt="">
      </div>
      <div class="qrcode-text">请先关注公众号，充电时有助于您实时接收充电的信息</div>
    </div>
  </div>
</template>

<script>
import { getOperInfo } from '../../common/api';
export default {
  name: 'pi-message',
  data () {
    return {
      operData: {},
    };
  },
  methods: {
    cancel () { this.cancelFn && this.cancelFn(); },
    getOperInfo(data){
      getOperInfo(data).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          this.operData = data.data[0];
        }
      })
    }
  },
  mounted () {

  }
};
</script>

<style lang="less" scoped>
.pi-wx-qrcode{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.5);
  .pi-wx-qrcode-box{
    width: 80%;
    background-color: #fff;
    border-radius: 0.2rem;
    padding: 0.4rem 0.2rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    .qrcode-img{
      width: 3.5rem;
      height: 3.5rem;
      margin: auto;
      img{
        width: 100%;
        height: 100%;
        pointer-events: auto;
      }
    }
    .qrcode-text{
      font-size: 0.32rem;
      line-height: 0.4rem;
      color: #666;
      margin-top: 0.2rem;
      text-align: center;
    }
  }
}
</style>
